import * as tslib_1 from "tslib";
import { QueryBuilder } from '../QueryBuilder/QueryBuilder';
var SiteMembersRequestBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(SiteMembersRequestBuilder, _super);
    function SiteMembersRequestBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SiteMembersRequestBuilder.prototype.filterByPrivacyStatus = function ($eq) {
        return this.addFilter({ profilePrivacyStatus: { $eq: $eq } });
    };
    return SiteMembersRequestBuilder;
}(QueryBuilder));
export { SiteMembersRequestBuilder };
//# sourceMappingURL=SiteMembersRequestBuilder.js.map